import type { Money } from 'shopify-types'

type VariantPricingInput = {
  price: Money
  compareAtPrice?: Money | null
  blackFridayPrice?: number | null
}

type VariantPricingResult = {
  price: Money
  compareAtPrice?: Money
}

export const getVariantPricing = ({
  price,
  compareAtPrice,
  blackFridayPrice,
}: VariantPricingInput): VariantPricingResult => {
  const higherCompareAtPrice =
    compareAtPrice && compareAtPrice.amount > price.amount ? compareAtPrice : null

  if (blackFridayPrice != null) {
    return {
      price: {
        amount: blackFridayPrice,
        currencyCode: price.currencyCode,
      },
      compareAtPrice: higherCompareAtPrice ?? price,
    }
  }

  return {
    price,
    compareAtPrice: higherCompareAtPrice ?? undefined,
  }
}
